import React from 'react';
import { Box, Typography, Grid, Button, Paper } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import BusinessIcon from '@mui/icons-material/Business';
import ContactsIcon from '@mui/icons-material/Contacts';
import {
  PRIVATE_USER_GESTION_DE_SERVICIOS,
  PRIVATE_USER_SERVICIOS_CONTRATADOS
} from 'DelegationService/DelegationService/Application/Constants/PathsConstants.js';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { GESTOR_DELEGACIONES_SERVICIOS, DELEGADO_DELEGACIONES_SERVICIOS } from 'Shared/Security/Application/Constants/PermissionsConstant';


export default function ServiceDelegationLandingView() {
  const navigate = useNavigate();
  const { checkPermission } = useAuthContext();
  const isStack = useMediaQuery('(max-width:1000px)');
  const [hasAdminPermission, setHasAdminPermission] = React.useState(false);
  const [hasDelegadoPermission, setHasDelegadoPermission] = React.useState(false);



  React.useEffect(() => {

    const admin = checkPermission(GESTOR_DELEGACIONES_SERVICIOS);
    const delegado = checkPermission(DELEGADO_DELEGACIONES_SERVICIOS);

    setHasAdminPermission(admin);
    setHasDelegadoPermission(delegado);

    if (!admin && !delegado) {
      navigate('../../../private/user', { replace: true });
    }
  }, [checkPermission,navigate]);


  const actions = [];

  if (hasAdminPermission) {
    actions.push({
      title: 'Gestión De Servicios',
      to: PRIVATE_USER_GESTION_DE_SERVICIOS,
      icon: <BusinessIcon />,
      color: 'primary',
      description: 'Gestión de los servicios'
    });
  };
  if (hasAdminPermission || hasDelegadoPermission) {
    actions.push({
      title: 'Servicios Contratados',
      to: PRIVATE_USER_SERVICIOS_CONTRATADOS,
      icon: <ContactsIcon />,
      color: 'info',
      description: 'Consulta los servicios contratados y los contactos'
    });
  };


  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" mb={1}>Delegaciones de Servicios</Typography>
      <Typography variant="body1" color="text.secondary" mb={3}>
        Selecciona una acción para continuar.
      </Typography>
      <Grid container spacing={isStack ? 7 : 2}>
        {actions.map((a) => (
          <Grid item xs={12} sm={isStack ? 12 : 6} md={isStack ? 12 : 3} key={a.title}>
            <Paper elevation={2} sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                {a.icon}
                <Typography variant="h6">{a.title}</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" mb={2}>{a.description}</Typography>
              <Button
                variant="contained"
                color={a.color}
                component={RouterLink}
                to={a.to}
                fullWidth={isStack}
              >
                Ir
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}